import { Download, Eye } from 'lucide-react';

/** Compact receipt opener — avoids a tall preview that forces modal scroll. */
export default function SettlementReceiptThumb({ url, onView, showDownload = false }) {
  if (!url) return null;
  return (
    <div className="rounded-xl border border-sky-100 bg-sky-50/60 px-2.5 py-2">
      <p className="text-[11px] font-semibold text-sky-900 mb-1.5">Receipt</p>
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={onView}
          className="inline-flex items-center gap-2 rounded-xl border border-sky-100 bg-white px-2 py-1.5 hover:bg-sky-100 hover:border-sky-300"
          title="View receipt"
        >
          <img src={url} alt="" className="w-9 h-9 rounded-lg object-cover shrink-0 border border-sky-100" />
          <span className="text-xs font-semibold text-sky-800 inline-flex items-center gap-1">
            <Eye className="w-3.5 h-3.5" />
            View receipt
          </span>
        </button>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[11px] text-sky-700 hover:underline"
        >
          Open in new tab
        </a>
        {showDownload ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            download
            className="inline-flex items-center gap-1 text-[11px] font-semibold text-sky-800 hover:underline"
          >
            <Download className="w-3.5 h-3.5" />
            Download receipt
          </a>
        ) : null}
      </div>
    </div>
  );
}
